import { Palette, Check } from 'lucide-react';
import { useState, useRef, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';

export function ThemePicker() {
  const { theme, setTheme, themes } = useTheme();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  return (
    <div className="relative" ref={wrapRef}>
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        aria-label="Change theme"
        title="Change theme"
        data-testid="theme-picker-button"
        className="w-8 h-8 flex items-center justify-center rounded-full text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
      >
        <Palette className="w-4 h-4" />
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 w-52 rounded-lg border border-border bg-popover text-popover-foreground shadow-lg z-50 py-1"
          data-testid="theme-picker-menu"
        >
          <div className="px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
            Display theme
          </div>
          {themes.map(t => (
            <button
              key={t.id}
              type="button"
              onClick={() => { setTheme(t.id); setOpen(false); }}
              data-testid={`theme-option-${t.id}`}
              className="w-full flex items-center gap-3 px-3 py-2 text-sm hover:bg-muted/60 transition-colors"
            >
              <span className="flex gap-0.5">
                {t.swatches.map((c, i) => (
                  <span key={i} className="w-3 h-3 rounded-sm border border-black/10" style={{ background: c }} />
                ))}
              </span>
              <span className="flex-1 text-left">{t.label}</span>
              {theme === t.id && <Check className="w-3.5 h-3.5 text-primary" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
